import React from 'react';
import DataViewerTwoColoms from '../DataViewerTwoColoms/DataViewerTwoColoms';
import './InfoBlock.css';

const InfoBlock = ({ icon, title, data, onDataChange, onDateChange }) => {
    return (
        <div className="info-block">
            <div className="info-block-header">
                <div className={`info-block-icon ${icon}`}></div>
                <h3 className="info-block-title">{title}</h3>
            </div>
            <div className="info-block-content">
                <DataViewerTwoColoms data={data} onDataChange={onDataChange} onDateChange={onDateChange} />
            </div>
        </div>
    );
};

export default InfoBlock; 
